import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ClaimToolElement } from "@shared/models/claim-tool-element.model";
import { ReferenceOptionsRequest } from "@shared/models/reference-options-request.model";
import { ReferenceOption } from "@shared/models/reference-option.model";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { AppState } from "@shared/redux/store";
import { ClaimToolService } from "@shared/services/claim-tool.service";
import { ReferencePhrase } from "@shared/models/common";
import { ClaimToolElementSaveChangesData } from "@shared/models/claim-tool-element-save-changes-data.model";

@Component({
    selector: 'doc-ref-options',
    templateUrl: './doc-ref-options.component.html',
    styleUrls: ['./doc-ref-options.component.scss'],
    standalone: false
})
export class DocReferenceOptionsComponent implements OnInit {
    
     @Input() referenceOptionsRequest: ReferenceOptionsRequest;

     @Input() disabled: boolean = false;

     loading = false;
     
     refOptions: ReferenceOption[] = [];

     selectedValue = 'all';
     

    constructor(private ngRedux: NgRedux<AppState>, private claimToolService: ClaimToolService) {}

    get claimToolElement(): ClaimToolElement {
      
      return this.ngRedux.getState().claimToolElement;
    }

    get claimToolSaveChangesDataInitialValues(): ClaimToolElementSaveChangesData {

      return this.ngRedux.getState().claimToolSaveChangesDataInitialValues;
    }
    displayedRefOptions: ReferenceOption[] = [];

   ngOnInit(): void {

        this.refOptions = [];
        this.loading = true;
        this.claimToolService.getRefOptions(this.referenceOptionsRequest).subscribe(
          (refOptions) => {
            this.refOptions = refOptions;
            this.displayedRefOptions = this.refOptions;
            this.loading = false;
            this.setReferences();

          },
          () => (this.loading = false) 
        )
    }

  add(phrase: ReferenceOption) {
    if (this.disabled) {
      return;
    } 
    
    phrase.is_phrase_ref = true;

    let idx = this.claimToolElement.deletedReferences.findIndex(
      (r) => r.refPhraseId == phrase.phrase_id
    );
    if (idx != -1) {

      this.claimToolElement.deletedReferences.splice(idx, 1);
    }
    //this.displayAssocTextOptions = false;
    let ref = new ReferencePhrase();
    ref.refPhraseId = phrase.phrase_id;
    ref.refPhraseText = phrase.phrase_text;
    ref.newSw = true;
    ref.phraseWords = JSON.parse(JSON.stringify(this.claimToolElement.phraseWords));
    ref.pointerWordId = this.claimToolElement.phraseWords[this.claimToolElement.phraseWords.length - 1].id;
    this.claimToolElement.references.push(ref);
    this.claimToolService.manageContextChanged$.next(this.compareWithInitialArray());
    //this.displayRefOptions = false;  }
  }

  remove(referenceOption: ReferenceOption) {
    if (this.disabled) {
      return;
    }
    
    referenceOption.is_phrase_ref = false;
    let idx = this.claimToolElement.references.findIndex(
      (r) => r.refPhraseId == referenceOption.phrase_id
    );
    if (idx != -1) {
      const referenceOption = this.claimToolElement.references[idx];
      this.claimToolElement.deletedReferences.push(referenceOption);
      this.claimToolElement.references.splice(idx, 1);
      this.claimToolService.manageContextChanged$.next(this.compareWithInitialArray());
    }
  }
    canRemovePhrase(phrase: ReferenceOption) {
      return (
           phrase.is_phrase_ref
      );
    }
    setReferences() {
      let initialReferences: ReferencePhrase[] = [];
      
      this.refOptions.forEach(refOption => {
        if (refOption.is_phrase_ref) {
            let reference: ReferencePhrase  = new ReferencePhrase();
            reference.refPhraseId = refOption.phrase_id;
            reference.refPhraseText = refOption.phrase_text;
            reference.refType = refOption.ref_type;
            reference.phraseWords = JSON.parse(JSON.stringify(this.claimToolElement.phraseWords));
          if (refOption.ref_pointer_word_id == null) {
            reference.pointerWordId = (this.claimToolElement.phraseWords[this.claimToolElement.phraseWords.length - 1].id);
          } else {
            reference.pointerWordId = refOption.ref_pointer_word_id;
          }
            initialReferences.push(reference);
            //set initially added reference options
            //set initially deleted reference options
        } 
      })
    this.claimToolSaveChangesDataInitialValues.references = JSON.parse(JSON.stringify(initialReferences));
    this.claimToolElement.references = initialReferences;
    }

    onFilterChange() {
      if (this.selectedValue == 'all') {
        this.displayedRefOptions = this.refOptions;
        return;
      }
        this.displayedRefOptions = this.refOptions.filter(refOption => refOption.ref_type == this.selectedValue);
    }

    private compareWithInitialArray(): boolean {

      const initialReferences = this.claimToolSaveChangesDataInitialValues.references;
      const currReferences = this.claimToolElement.references;

      if (initialReferences.length != currReferences.length) {
        // reference deleted 
        // reference added  
        return true;
      }
      // same length
      // reference added and reference deleted
      // we need to check if reference is added that werent in array
      for (let i=0; i<currReferences.length; i++) {
        
        const currReference = currReferences[i];
        const foundedReference = initialReferences.findIndex(reference => currReference.refPhraseId == reference.refPhraseId);
        
        if (foundedReference == -1) {
          // added reference
          // not in initial references
          return true;
        }
      }
      return false;
    }
    

}